import React from 'react';
import PropTypes from 'prop-types';
import { Container } from '@raketa-cms/raketa-cms';
import { Parallax } from 'react-scroll-parallax';

import ParallaxImage from '../ParallaxImage';

const AxSectionWidget = ({ link, title, text, parallax_full_width, containerSettings }) => (
  <Container settings={containerSettings} className="parallax">
    <a href={link} className="parallax-box ax-section">
      <div className="full-width-image-mask">
        <Parallax
          offsetXMin={-100}
          offsetXMax={100}
          slowerScrollRate
          tag="figure"
        >
          <div style={{ width: '2500px', height: '900px', backgroundColor: 'rgba(0,0,0,.8)' }} />
        </Parallax>
      </div>

      <div className="full-width-image">
        <Parallax
          offsetYMin={-50}
          offsetYMax={50}
          slowerScrollRate
          tag="figure"
        >
          <ParallaxImage src={parallax_full_width} variant="parallax_full_width" />
          <ParallaxImage src={parallax_full_width} variant="parallax_full_width_mobile" />
        </Parallax>
      </div>

      <div className="letter-bg"></div>

      <Parallax
        className="title"
        offsetYMin={-10}
        offsetYMax={1000}
        tag="div"
      >
        <h1>{title}</h1>
      </Parallax>

      <Parallax
        className="letter"
        offsetYMin={-10}
        offsetYMax={1000}
        tag="div"
      >
        <div className="letter-wrapper ax">
          <img src="data:image/svg+xml;base64,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" />
        </div>
      </Parallax>

      <div className="text" dangerouslySetInnerHTML={{ __html: text }} />
    </a>
  </Container>
);

AxSectionWidget.title = 'AX Section';
AxSectionWidget.category = 'Parallax Homepage';

AxSectionWidget.propTypes = {
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  parallax_full_width: PropTypes.any.isRequired,
  containerSettings: PropTypes.object.isRequired,
};

AxSectionWidget.defaults = {
  link: '#',
  title: 'Title',
  text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta quibusdam eius voluptate repudiandae odio aut, ea voluptas. In consectetur praesentium minus molestiae fuga hic? Tempore consequuntur debitis maiores laudantium aliquid.',
  parallax_full_width: 'http://via.placeholder.com/1680x630',
  containerSettings: {},
};

AxSectionWidget.adminFields = {
  link: { type: 'text' },
  parallax_full_width: { type: 'image' },
  title: { type: 'text' },
  text: { type: 'rich' },
};

export default AxSectionWidget;
